// Точка входа сайта: только лендинг v3. Старый кабинет и лендинги v1/v2 остаются в репозитории
// (src/ts/app.legacy.ts, src/ts/router.legacy.ts, src/page/app.legacy.vue), но в сборку не входят.
import { createApp } from 'vue'
import App from '@/page/app.vue'
import router from '@/ts/router'
import '@/page/landing_v3/landing.css'

const app = createApp(App)
app.use(router)
router.isReady().then(() => app.mount('#app'))

// Документ прокручен ровно на подкладку над вьюпортом (body padding-top в landing.css) и удерживается там;
// сам контент прокручивается внутри #app. Зачем — см. комментарий в landing.css.
const SPACER = 300
const pin = () => window.scrollTo(0, SPACER)
pin()
addEventListener('scroll', pin, { passive: true })
addEventListener('resize', pin)
window.visualViewport?.addEventListener('resize', pin)
